export default __webpack_public_path__ + "static/media/gift-payment-failure-mobile.2fe47a3a.webp";